<script>
  import { mapActions, mapState } from 'vuex'

  /**
  * Sidenav component
  */
  export default {
    data() {
      return {
        levels: {
          0: {
            itemId: null,
            enabled: false,
            dropdown: true,
          },
          1: {
            itemId: null,
          },
          2: {
            itemId: null,
          },
        },
        // Added by MC Consulting
        staticLevels: {
          'room-areas': {
            id: null,
            enabled: false
          },
          'inventory-items': {
            id: null,
            enabled: false
          },
        },
        areaCategory: null,
        propertyCategory: null,
      };
    },
    created() {
      this.loadMenu(this.toggleLevelItems);
    },
    computed: {
      ...mapState("menu", ["menu", "properties"]),
      currentCategory() {
        // Get current category from route param
        return this.$route.params.category || '';
      }
    },
    watch: {
      $route: function() {
        const items = Object.values(this.menu);

        this.toggleLevelItems(items);
      },
    },
    methods: {
      ...mapActions("menu", ["loadMenu", "selectMenuItem"]),

      hasItems(item) {
        return item.subItems !== undefined ? item.subItems.length > 0 : false;
      },
      toggleMenuItem(menuItem, { level, onClick }) {
        const selectedLevel = this.levels[level];
        if (selectedLevel.dropdown)
          if (!onClick || selectedLevel.itemId != menuItem.id) {
            // on page load or route change
            // OR
            // there must have been a click on another dropdown
            selectedLevel.itemId = menuItem.id;
            selectedLevel.enabled = true;
            for(let l = level + 1; l < Object.keys(this.levels).length; l++)
              this.levels[l].itemId = null;
          } else // toggle current dropdown
            selectedLevel.enabled = !selectedLevel.enabled;
        else // not a dropdown, there must have been a route change of the same type
          selectedLevel.itemId = menuItem.id;
      },
      /**
       *  Added by MC Consulting
       */
      toggleStaticMenuItem(menuItem, id, forceEnable) {
        // disable all static menus
        this.staticLevels['room-areas'].enabled = false;
        this.staticLevels['inventory-items'].enabled = false;

        const selectedLevel = this.staticLevels[menuItem];

        selectedLevel.id = id;
        if (forceEnable) selectedLevel.enabled = true;
        else selectedLevel.enabled = !selectedLevel.enabled;
      },
      toggleLevelItems(items) {
        const pathname = window.location.pathname,
              urlParts = pathname.split('/').filter(key => key && key != ''),
              titleNamespace = urlParts.shift();
              
        let titleItem = items.find(item => (item.namespace || item.link) == `/${titleNamespace}`);

        if (! titleItem ) {
          // We're on landing page -- default to properties
          titleItem = items.find( item => (item.namespace == '/properties') );
        }

        let levelItems = [titleItem];

        if (titleNamespace == 'properties') {
          const propertyId = urlParts.shift();

          if (propertyId) {
            const propertyItem = titleItem.subItems.find(item => item.propertyId == propertyId);
            levelItems.push(propertyItem);

            const areaNamespace = urlParts.shift();
            if (areaNamespace) {
              const areaId = urlParts.shift();
              if (areaId) levelItems.push(propertyItem.subItems.find(item => item.areaId == areaId));
            }
          }
        }

        if ( pathname.match(/\/properties\/[0-9]+\/category\//) ) {
          this.propertyCategory = this.currentCategory;
        }
        if ( pathname.match(/\/properties\/[0-9]+\/areas\/[0-9]+\/category\//) ) {
          this.areaCategory = this.currentCategory;
        }

        levelItems.filter(key => !!key).forEach(
          (levelItem, index) => {
            this.toggleMenuItem(
              levelItem,
              { level: index }
            );
            // Added by MC Consulting
            if (index == 2) { // Assume this index reserved for areas/rooms
              this.toggleStaticMenuItem('room-areas', levelItem.parentId, true);
            }
            else if ( this.currentCategory && pathname.match(/\/properties\/[0-9]+\/category\//) ) {
              this.toggleStaticMenuItem('inventory-items', levelItem.parentId, true);
            }

          }
        );
      },
      sortedItemCategories(itemCategories) {
        // Check if itemCategories is an object
        if (typeof itemCategories === 'object' && !Array.isArray(itemCategories)) {
          // Convert object to array of key-value pairs
          const categoriesArray = Object.entries(itemCategories);

          // Sort categories array alphabetically based on label (key)
          categoriesArray.sort((a, b) => {
            return a[0].localeCompare(b[0]); // Compare keys alphabetically
          });

          // Extract values from sorted array
          const sortedCategories = categoriesArray.map(([_key, value]) => value);

          return sortedCategories;
        } else {
          // Return itemCategories as is if it's not an object
          return itemCategories;
        }
      },
    },
  };
</script>

<style>
.fa {
  font-weight: 900 !important;
}
.far {
  font-weight: 400 !important;
}
</style>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled" >
      <template v-for="titleItem in this.menu">
        <li class="menu-title" v-if="titleItem.isTitle" :key="`${titleItem.id}-title`">
          {{ $t(item.label) }}
        </li>

        <li :key="`${titleItem.id}-label`">

          <!-- menu title with items like Properties, Items -->
          <a
            v-if="hasItems(titleItem)"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !titleItem.badge, 'has-dropdown': titleItem.badge, 'mm-active': levels[0].itemId == titleItem.id }"
            @click="toggleMenuItem(titleItem, { level: 0, onClick: true })"
          >
            <i :class="titleItem.icon" v-if="titleItem.icon"></i>
            <span class="title" >{{ $t(titleItem.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${titleItem.badge.variant} float-end`"
              v-if="titleItem.badge"
            >
              {{ $t(titleItem.badge.text) }}
            </span>
          </a>

          <!-- menu title without items like Profile -->
          <router-link
            v-if="!hasItems(titleItem)"
            :to="titleItem.link"
            class="side-nav-link-ref"
            :class="{ 'mm-active': levels[0].itemId == titleItem.id }"
          >
            <i :class="titleItem.icon" v-if="titleItem.icon"></i>
            <span class="title">{{ $t(titleItem.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${titleItem.badge.variant} float-end`"
              v-if="titleItem.badge"
            >
              {{ $t(titleItem.badge.text) }}
            </span>
          </router-link>

          <transition name="scale">
            <ul v-if="hasItems(titleItem) && levels[0].itemId == titleItem.id && levels[0].enabled" class="sub-menu" aria-expanded="false">
              <li v-for="(subItem, index) of titleItem.subItems" :key="index">
                <!-- first level sub-links like property names -->
                <router-link
                  :to="subItem.link"
                  :key="subItem.id"
                  class="side-nav-link-ref has-arrow"
                  :class="{ 'mm-active': levels[1].itemId == subItem.id }"
                >
                  <span class="thumbnail" v-if="titleItem.label == 'Properties'">
                    <img v-if="subItem.thumbnail" :src="subItem.thumbnail" width="50" height="50">
                  </span>

                  <span class="category">{{ $t(subItem.label) }}</span>
                  <span :class="`badge rounded-pill bg-${subItem.badge.variant} float-end`" v-if="subItem.badge">{{ $t(item.badge.text) }}</span>
                </router-link>

                <transition name="scale">
                  <ul v-if="hasItems(subItem) && levels[1].itemId == subItem.id" class="sub-menu" aria-expanded="false">
                    <!-- second level sub-links like 360 view and area names -->
                    <li>
                       <b-link v-if="subItem.virtualTourLink" class="virtual-tour" v-b-modal.modal-VirtualTourView>
                        <i class="fa fa-cube"></i> {{ $t('VIRTUAL TOUR') }}</b-link>
                    </li>
                    <li>
                      <b-link v-if="subItem.roofReport" :href="subItem.roofReport.file_url" class="roof-report" target="_blank">
                        <i class="fa fa-file-pdf"></i> {{ $t('ROOF REPORT') }}</b-link>
                    </li>
                    <li>
                      <a v-if="Object.keys(subItem.itemCategories).length" href="#" class="inventory-items has-arrow" :class="{ 'mm-active': staticLevels['inventory-items'].id == subItem.id && staticLevels['inventory-items'].enabled }" @click="toggleStaticMenuItem('inventory-items', subItem.id, false)">
                        <i class="fa fa-box-open"></i> {{ $t('All INVENTORY ITEMS') }}</a>

                       <!-- Categories -->
                      <transition name="scale">
                        <ul v-if="staticLevels['inventory-items'].id == subItem.id && staticLevels['inventory-items'].enabled" class="sub-menu item-category" aria-expanded="false">
  <li v-for="(itemCategory, index) of sortedItemCategories(subItem.itemCategories)" :key="index">
    <router-link :to="itemCategory.link" :class="{ 'mm-active': propertyCategory == index }">
      <span v-if="itemCategory.category" class="category-icon">
        <img :src="require(`@/assets/images/icons/${itemCategory.category.icon}`)">
      </span>
      <span class="category">{{ itemCategory.label }}</span>
    </router-link>
  </li>
</ul>


                      </transition>
                    </li>
                    
                    <li>
                       <a class="room-areas has-arrow" :class="{ 'mm-active': staticLevels['room-areas'].id == subItem.id && staticLevels['room-areas'].enabled }" href="#" @click="toggleStaticMenuItem('room-areas', subItem.id, false)">
                        <i class="fa fa-door-open"></i> {{ $t('ROOM AREAS') }}</a> 
                        <transition name="scale">
                          <ul v-if="hasItems(subItem) && staticLevels['room-areas'].id == subItem.id && staticLevels['room-areas'].enabled" class="sub-menu room-areas" aria-expanded="false">
                            <li v-for="(subItem2, index) of subItem.subItems" :key="index">
                              <router-link
                                :to="subItem2.link"
                                v-if="!hasItems(subItem2)"
                                class="side-nav-link-ref has-arrow"
                                :class="{ 'mm-active': levels[2].itemId == subItem2.id }"
                              >
                                <!-- Property Sub Items -->
                                <span>{{ $t(subItem2.label) }}</span>
                                <span :class="`badge rounded-pill bg-${subItem2.badge.variant} float-end`" v-if="subItem2.badge">{{ $t(subItem2.badge.text) }}</span>
                              </router-link>
                              <transition name="scale">
                                <ul class="sub-menu inventory-items" aria-expanded="false">
                                  <li>
                                     <a v-if="levels[2].itemId == subItem2.id" class="inventory-items"  href="#">
                                      <i class="fa fa-box-open"></i> {{ $t('INVENTORY ITEMS') }}</a>

                                      <!-- Categories -->
                                      <transition name="scale">
                                        <ul v-if="levels[2].itemId == subItem2.id" class="sub-menu item-category" aria-expanded="true">
                                          <li v-for="(itemCategory, index) of subItem2.itemCategories" :key="index">
                                            <router-link :to="itemCategory.link" :class="{ 'mm-active': areaCategory == index }">
                                              <span v-if="itemCategory.category" class="category-icon">
                                                <img :src="require(`@/assets/images/icons/${itemCategory.category.icon}`)"></span> 
                                              <span class="category">{{ itemCategory.label }}</span>
                                            </router-link>

                                          </li>
                                        </ul>
                                      </transition>
                                  </li>
                                </ul>
                              </transition>
                            </li>
                          </ul>
                        </transition>
                    </li>
                    
                    <!-- REMOVED AREAS -->
                  </ul>
                </transition>
              </li>

            </ul>
          </transition>
        </li>

      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
